import { render, staticRenderFns } from "./LastVideo.vue?vue&type=template&id=0459ead6&scoped=true"
import script from "./LastVideo.vue?vue&type=script&lang=ts"
export * from "./LastVideo.vue?vue&type=script&lang=ts"
import style0 from "./LastVideo.scss?vue&type=style&index=0&id=0459ead6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0459ead6",
  null
  
)

export default component.exports